export interface Modal {
    loading: boolean;
    visible: boolean;
}

export const DefaultModal = () => {
    return {
        loading: false,
        visible: false
    } as Modal;
}
